import { customElement } from "lit/decorators.js";
import { Chart, type ChartDefinition } from "../Chart";

@customElement("s-pewma-histogram-chart")
export class PewmaHistogramChart extends Chart {
	protected override readonly definition: ChartDefinition = {
		title: "Latency histogram",
		summary:
			"PEWMA's requests cluster in lower-latency bins and its tail ends earlier than least connections.",
		xMinimum: 0,
		xMaximum: 2400,
		xTickStep: 500,
		yMinimum: 0,
		yMaximum: 50,
		xAxisTitle: "Response time (ms)",
		yAxisTitle: "Number of requests",
		series: [
			{
				name: "PEWMA",
				points: [
					{ x: 465, y: 7 },
					{ x: 515, y: 7 },
					{ x: 565, y: 18 },
					{ x: 615, y: 13 },
					{ x: 665, y: 35 },
					{ x: 715, y: 34 },
					{ x: 765, y: 50 },
					{ x: 815, y: 34 },
					{ x: 865, y: 46 },
					{ x: 915, y: 40 },
					{ x: 965, y: 31 },
					{ x: 1015, y: 28 },
					{ x: 1065, y: 24 },
					{ x: 1115, y: 10 },
					{ x: 1165, y: 9 },
					{ x: 1215, y: 17 },
					{ x: 1265, y: 6 },
					{ x: 1315, y: 6 },
					{ x: 1365, y: 3 },
					{ x: 1415, y: 3 },
					{ x: 1465, y: 6 },
					{ x: 1515, y: 4 },
					{ x: 1565, y: 4 },
					{ x: 1615, y: 1 },
					{ x: 1665, y: 1 },
					{ x: 1715, y: 4 },
					{ x: 1865, y: 1 },
				],
				color: "var(--chart-red)",
				texture: "dash-dot",
				legendLabel: "PEWMA",
			},
			{
				name: "Least connections (LC)",
				points: [
					{ x: 435, y: 2 },
					{ x: 485, y: 14 },
					{ x: 535, y: 11 },
					{ x: 585, y: 18 },
					{ x: 635, y: 15 },
					{ x: 685, y: 17 },
					{ x: 735, y: 40 },
					{ x: 785, y: 29 },
					{ x: 835, y: 37 },
					{ x: 885, y: 44 },
					{ x: 935, y: 39 },
					{ x: 985, y: 34 },
					{ x: 1035, y: 23 },
					{ x: 1085, y: 16 },
					{ x: 1135, y: 7 },
					{ x: 1185, y: 18 },
					{ x: 1235, y: 7 },
					{ x: 1285, y: 5 },
					{ x: 1335, y: 18 },
					{ x: 1385, y: 2 },
					{ x: 1435, y: 3 },
					{ x: 1485, y: 5 },
					{ x: 1535, y: 9 },
					{ x: 1585, y: 3 },
					{ x: 1635, y: 7 },
					{ x: 1685, y: 2 },
					{ x: 1735, y: 5 },
					{ x: 1835, y: 1 },
					{ x: 1935, y: 4 },
					{ x: 2035, y: 3 },
					{ x: 2085, y: 2 },
					{ x: 2335, y: 1 },
					{ x: 2385, y: 1 },
				],
				color: "var(--chart-green)",
				texture: "dotted",
				legendLabel: "Least Connections",
			},
		],
	};

	protected override readonly histogram = true;
}
